var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.003,
    viewBox: "0 0 24 24.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twotone-closed_caption-24px",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4929",
    "data-name": "Caminho 4929",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4932",
    "data-name": "Caminho 4932",
    d: "M0,20H24v4H0Z",
    fill: "rgba(46,128,195,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4930",
    "data-name": "Caminho 4930",
    d: "M14,6.08l-8,8V15h.92l8-8Z",
    fill: "rgba(46,128,195,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4931",
    "data-name": "Caminho 4931",
    d: "M14,3.25l-10,10V17H7.75l10-10ZM6.92,15H6v-.92l8-8,.92.92ZM20.71,4.04a1,1,0,0,0,0-1.41L18.37.29a1,1,0,0,0-1.41,0L15,2.25,18.75,6Z",
    fill: "#2e80c3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.8780b4fede8de19f3240e06aa4a3b67f.svg";
export { ForwardRef as ReactComponent };